import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';

import CardHeader from "../../modules/Card/CardHeader.jsx";
import SchedulerComponent from './SchedulerComponent';
import IntegrationReactSelect from '../Common/IntegrationReactSelect';

import { connect } from 'react-redux';
import { compose } from "recompose";
import { userActions, tasksissuesActions, projectActions } from '../../_actions';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
    },
    paper: {
        position: 'absolute',
        [theme.breakpoints.down('sm')]: {
            width: '90%',
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    title: {
        flex: '0 0 auto',
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    scheduler:
        theme.palette.type === 'light'
            ? {
                color: 'black',
            }
            : {
                color: 'white',
            },
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            projectId: []
        };

        this.handleRenewClick = this.handleRenewClick.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(userActions.getAll());
        this.props.dispatch(projectActions.getAllByUserId(this.props.user.id));
        this.props.dispatch(tasksissuesActions.getAllByUserId(this.props.user.id));
    }

    handleSelectData = (data) => {
        this.setState({
            projectId: data.id
        })
    }

    handleRenewClick = () => {
        this.setState({
            projectId: []
        })
    }

    handleMoveData = (MoveData) => {
        const DataProcessing = async () => {
            try {
                await this.props.dispatch(tasksissuesActions.update(MoveData));
                await this.props.dispatch(tasksissuesActions.getAllByUserId(this.props.user.id));
            } catch (e) {
                console.error("Problem", e)
            }
        }

        DataProcessing();
    }

    render() {
        const { classes, user, tasksissues, users, projects } = this.props;

        return (
            <Paper style={{ paddingBottom: '20px' }}>
                <Toolbar className={classes.root}>
                    <div className={classes.title}>
                        <CardHeader color="success">
                            <div style={{ height: '5vh' }}>Tasks Diagram</div>
                        </CardHeader>
                    </div>
                    <div style={{ width: '20%' }}>
                        <IntegrationReactSelect
                            handleSelectData={this.handleSelectData}
                            options={convertProjectsOptions(projects.items, user.departmentId, this.props.user.id)}
                            valid={true}
                            value={this.state.projectId}
                            placeholder='Projects'
                        />
                    </div>
                    <IconButton onClick={this.handleRenewClick}>
                        <SettingsBackupRestoreIcon />
                    </IconButton>
                </Toolbar>
                <div className={classes.scheduler}>
                    <SchedulerComponent
                        projectId={this.state.projectId}
                        userId={user.id}
                        departmentId={user.departmentId}
                        data={dataConvert(tasksissues.items)}
                        resources={resourcesConvert(users.items, user.departmentId)}
                        handleMoveData={this.handleMoveData} />
                </div>
            </Paper>
        );
    }
}

function dataConvert(data) {
    let resources = data ? data.filter(item => {
        return item.OUserUserStatus === 'A' && item.AUserUserStatus === 'A'
    }) : [];

    return resources
}

function resourcesConvert(data, departmentId) {
    var resources = [];
    data && data.filter(item => {
        return item.UserStatus === 'A'
    }).forEach(function (element, index, array) {
        if (element.DepartmentId === departmentId) {
            const json = {
                id: element.UserId,
                name: element.UserName
            }
            resources.push(json)
        }
    })

    return resources
}

function convertProjectsOptions(data, departmentId, userId) {
    const options = data ? data.filter(findDepartmentId).map((data) => ({
        label: data.ProjectName ? data.ProjectName : null + data.PipedriveJSON.title ? 'Deal Title: ' + data.PipedriveJSON.title : null,
        id: data.ProjectId,
        type: 'Projects'
    })) : [];

    function findDepartmentId(element) {
        if (element.ProgressStatus !== '3' || element.ProgressStatus !== '4') {
            return true
        }
    }

    return options
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { tasksissues, users, projects } = state;

    return {
        user,
        tasksissues,
        users,
        projects,
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles))(App);



// WEBPACK FOOTER //
// ./src/components/TasksDiagram/App.js